import { RPRepository } from '../repositories/rp.repository'
import { RPGetParamsT, RPItemResponseT, RPResponseT } from '@/core/types/rp.types'

const rpRepository = new RPRepository()

export class RPService {
    async generateRP(): Promise<{ message: string }> {
        const response = await rpRepository.generateRP()
        return response.data
    }

    async getList(params: RPGetParamsT): Promise<RPResponseT> {
        const response = await rpRepository.getList(params)
        return response.data
    }

    async getRP(id: number): Promise<RPItemResponseT> {
        const response = await rpRepository.getRP(id)
        return response.data
    }

    async exportRPKListExcel(id: number): Promise<any> {
        const response = await rpRepository.exportRPKListExcel(id)
        return response.data
    }

    async exportRPPListExcel(id: number): Promise<any> {
        const response = await rpRepository.exportRPPListExcel(id)
        return response.data
    }

    async getExpressList(page: number): Promise<any> {
        const response = await rpRepository.getExpressList(page)
        return response.data
    }

    async generateExpressRP(): Promise<any> {
        const response = await rpRepository.generateExpressRP()
        return response.data
    }

    async exportExpressRPKListExcel(id: number): Promise<any> {
        const response = await rpRepository.exportExpressRPKListExcel(id)
        return response.data
    }
}
